import { tagged } from "@mirage/service-logging";
import {
  addTrackToSection,
  createEmptySectionTrackingRecord,
} from "@mirage/shared/search/section-tracking-record";

import type { MemoryCache } from "@mirage/service-typeahead-search/service/typeahead-cache/subcaches";
import type {
  RecentSectionTrack,
  SectionTrackingRecord,
} from "@mirage/shared/search/section-tracking-record";
import type { typeahead } from "../../types";

const logger = tagged("section-tracking-cache");

class SectionTrackingCache implements MemoryCache<SectionTrackingRecord> {
  private cache: SectionTrackingRecord[] = [createEmptySectionTrackingRecord()];

  all() {
    return this.cache;
  }

  clear() {
    this.cache = [createEmptySectionTrackingRecord()];
  }

  count() {
    return this.cache.length;
  }

  addItems(items: SectionTrackingRecord[]): Promise<SectionTrackingRecord[]> {
    if (items.length === 1) {
      this.clear();
      this.cache = items;
    }

    return Promise.resolve(this.cache);
  }

  removeItem(_item: SectionTrackingRecord): Promise<SectionTrackingRecord[]> {
    throw new Error("Method not implemented.");
  }

  async trackSectionInteraction(
    sectionId: typeahead.SectionId | undefined,
    trackPayload: RecentSectionTrack,
  ) {
    logger.debug(
      "Tracking section for sectionId",
      sectionId,
      "at",
      trackPayload.timestamp,
    );

    const sectionIdUnion = sectionId ?? "__none__";

    this.cache[0] = addTrackToSection(
      this.cache[0],
      sectionIdUnion,
      trackPayload,
    );

    return Promise.resolve(this.cache);
  }
}

export default SectionTrackingCache;
